<ng-container *ngIf="agreement; else NoAgreement">
  <div class="container" *ngIf="!orderPlaced">
    <div class="card agreement-detail">
      <div class="row card-body agreement-detail-content">
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.endUserNumber' | cxTranslate }}</b>
          <span>{{ agreement.endCustomer?.orgUnit?.uid }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.endCustomerBNFull' | cxTranslate }}</b>
          <span>{{ agreement.endCustomer?.orgUnit?.businessNumber }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.startDate' | cxTranslate }}</b>
          <span>{{ agreement.startDate | cxDate: 'longDate' }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.endUserDescription' | cxTranslate }}</b>
          <span>{{ agreement.endCustomer?.orgUnit?.name }}</span>
        </div>
        <div class="col-12 col-sm-6 col-md-4 card-body--label">
          <b>{{ 'dispenserAgreement.salesOrganisation' | cxTranslate }}</b>
          <span>{{ agreement.salesOrganisation }}</span>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #NoAgreement>
  <app-custom-error *ngIf="!showInitialLoader" [errorMessage]="'shared.noAgreements' | cxTranslate"></app-custom-error>
</ng-template>

<div *ngIf="showInitialLoader" class="cx-spinner">
  <cx-spinner></cx-spinner>
</div>

<ng-container *ngIf="orderPlaced">
  <app-order-placed
    [agreement]="agreement"
    [shipment]="shipment"
    [quantityOrdered]="totalQuantity"
    [isCreditNoteRequest]="shipCreditNote"
    [finalFormattedAddress]="finalFormattedAddress"
    [user]="userService.get() | async"
    (eventBack)="backToHistory()"
  ></app-order-placed>
</ng-container>

<mat-horizontal-stepper
  class="stepper"
  labelPosition="bottom"
  #dispenserPlaceOrderStepper
  *ngIf="agreement && !orderPlaced"
>
  <mat-step [stepControl]="shipSelectFormGroup">
    <form [formGroup]="shipSelectFormGroup" (keydown.enter)="$event.preventDefault()">
      <ng-template matStepLabel
        ><label class="description-title">{{
          'dispenserAgreement.shipToAndDispenserSelection' | cxTranslate
        }}</label></ng-template
      >
      <mat-card class="dispenser-agreement-order__body">
        <div *ngIf="!showSubmitLoader">
          <h3 class="dispenser-agreement-order__body__title">
            {{ 'dispenserAgreement.shipToSelect' | cxTranslate }}
          </h3>
          <div class="dispenser-agreement-order__body__section">
            <div class="dispenser-agreement-order__body__section__content">
              <div class="ship-to">
                <button
                  [ngClass]="{
                    'btn-action': !shipCreditNote,
                    'btn-primary': shipCreditNote,
                    'btn ship-to-button': true
                  }"
                  mat-button
                  formcontrolname="shipToSelect"
                  (click)="selectCreditNote()"
                >
                  {{ 'dispenserAgreement.requestCreditNote' | cxTranslate }}
                </button>
                <button
                  [ngClass]="{
                    'btn-action': !shipEndUserDepot,
                    'btn-primary': shipEndUserDepot,
                    'btn ship-to-button': true
                  }"
                  *ngIf="agreement.endUserDelivery"
                  mat-button
                  formcontrolname="shipToSelect"
                  (click)="selectEndUserDepot()"
                >
                  {{ 'dispenserAgreement.shipEndUserDepot' | cxTranslate }}
                </button>
                <button
                  [ngClass]="{
                    'btn-action': !shipDistributorDepot,
                    'btn-primary': shipDistributorDepot,
                    'btn ship-to-button': true
                  }"
                  mat-button
                  formcontrolname="shipToSelect"
                  (click)="selectDistributorDepot()"
                >
                  {{ 'dispenserAgreement.shipDistributorDepot' | cxTranslate }}
                </button>
              </div>
            </div>
          </div>

          <div class="dispenser-agreement-order__body__section" *ngIf="shipSelection">
            <h3 class="dispenser-agreement-order__header">
              {{ 'dispenserAgreement.dispenserSelection' | cxTranslate }}
            </h3>
            <div class="dispenser-agreement-order__body__section__content">
              <app-custom-table
                *ngIf="agreement.entries; else NoEntries"
                [headers]="headers"
                [columns]="columns"
                override="DispenserAgreementProductRows"
                (changeValue)="changeDispenserQuantity($event)"
                rowId="product.code"
                [rows]="agreement.entries"
              ></app-custom-table>
              <ng-template #NoEntries>
                <app-custom-error
                  *ngIf="showMessageWhenNoData"
                  [errorMessage]="'shared.noEntries' | cxTranslate"
                ></app-custom-error>
              </ng-template>
            </div>
          </div>
          <div class="action-button" *ngIf="shipSelection">
            <button
              class="btn btn-primary"
              *ngIf="shipCreditNote; else Next"
              [disabled]="disableOnInvalidQuantity"
              (click)="placeDispenserOrder()"
            >
              Submit
            </button>
            <ng-template #Next>
              <button
                class="btn btn-primary"
                matStepperNext
                *ngIf="shipEndUserDepot"
                [disabled]="disableOnInvalidQuantity"
              >
                Next
              </button>
              <button
                class="btn btn-primary"
                matStepperNext
                *ngIf="shipDistributorDepot"
                [disabled]="disableOnInvalidQuantity || disableWhenNoDistributorAddress"
              >
                <i *ngIf="loadingDistributorAddresses" class="fa fa-spinner fa-spin"></i>
                <span *ngIf="!loadingDistributorAddresses">Next</span>
              </button>
            </ng-template>
          </div>
        </div>
        <div *ngIf="showSubmitLoader" class="cx-spinner">
          <cx-spinner></cx-spinner>
        </div>
      </mat-card>
    </form>
  </mat-step>
  <mat-step [stepControl]="addressSelectFormGroup" *ngIf="!shipCreditNote && shipSelection">
    <form [formGroup]="addressSelectFormGroup" (keydown.enter)="$event.preventDefault()">
      <ng-template matStepLabel
        ><label class="description-title">{{ 'dispenserAgreement.addressSelection' | cxTranslate }}</label></ng-template
      >
      <mat-card class="dispenser-agreement-order__body">
        <h3 class="dispenser-agreement-order__body__title">
          {{ 'dispenserAgreement.addressSelection' | cxTranslate }}
        </h3>
        <div class="dispenser-agreement-order__body__section">
          <div class="dispenser-agreement-order__body__section__content" *ngIf="shipDistributorDepot">
            <div class="form-check col-4 col-md-4 col-lg-4 start-padding">
              <div class="dispenser-form-info">
                <ng-select
                  formControlName="selectedDistributorAddress"
                  [clearOnBackspace]="false"
                  [clearable]="false"
                  placeholder="Select address"
                  (change)="selectDistributorAddress($event)"
                >
                  <ng-option *ngFor="let address of distributorAddresses | keyvalue" [value]="address.key">
                    {{ address.value.formattedAddress }}
                  </ng-option>
                </ng-select>
              </div>
            </div>
            <div class="form-group row date-picker">
              <div class="col-4">
                <label>
                  <ng-template #tipContent>
                    <div class="preferred-date-hint">
                      <span>{{ 'checkoutShipping.dispenserPreferredDateHint' | cxTranslate }}</span>
                    </div>
                  </ng-template>
                  <span class="label-content"
                    >Requested Dispatch Date
                    <i class="fas fa-info-circle info-icon" [ngbTooltip]="tipContent"></i>
                  </span>
                  <input
                    [matDatepicker]="picker"
                    [min]="minDate"
                    aria-label="request-delivery-date"
                    class="form-control"
                    type="text"
                    name="requestedDeliveryDate"
                    placeholder="Requested dispatch date"
                    [matDatepickerFilter]="holidaysAndDeliverydaysFilter"
                    formControlName="requestedDeliveryDate"
                    readonly
                  />
                  <mat-datepicker #picker></mat-datepicker>
                </label>
                <button class="btn date-picker__search-icon" (click)="openDatePicker(picker)">
                  <i class="fas fa-calendar-alt"></i>
                </button>
              </div>
              <div class="form-check col-4 col-md-4 col-lg-4">
                <div class="dispenser-form-info">
                  <label>
                    <span class="label-content">{{ 'checkoutPO.poNumber' | cxTranslate }}</span>
                    <input
                      class="form-control ng-untouched ng-pristine ng-valid"
                      type="text"
                      formControlName="poNumber"
                      placeholder="{{ 'checkoutPO.placeholder' | cxTranslate }}"
                      value=""
                    />
                  </label>
                </div>
              </div>
              <div class="form-check col-8 col-md-8 col-lg-8">
                <div class="row">
                  <app-minimum-dispatch-time></app-minimum-dispatch-time>
                </div>
              </div>
            </div>
            <div class="form-check col-8 col-md-8 col-lg-8 start-padding">
              <div class="dispenser-form-info">
                <span class="label-content">Delivery Instructions</span>
                <textarea
                  class="form-control ng-untouched ng-pristine ng-valid"
                  formControlName="deliveryInstructions"
                  placeholder="Enter instructions"
                  [maxlength]="220"
                  rows="3"
                >
                </textarea>
              </div>
            </div>
          </div>

          <div class="dispenser-agreement-order__body__section__content" *ngIf="shipEndUserDepot">
            <ng-container *ngIf="endCustomerAddress">
              <div role="group" aria-label="Basic radio toggle button group">
                <div class="form-check col-6 col-md-6 col-lg-6 start-padding">
                  <p>Is End User Address is the same as Ship To Address</p>
                </div>
                <div class="form-check col-3 col-md-3 col-lg-3">
                  <input
                    class="form-check-input"
                    role="radio"
                    type="radio"
                    aria-checked="false"
                    value="yes"
                    name="sameShippingAddress"
                    formControlName="sameShippingAddress"
                  />
                  <label class="cx-payment-type-label form-check-label form-radio-label" for="Yes">
                    <div class="cx-payment-type">Yes</div>
                  </label>
                </div>
                <div class="form-check col-3 col-md-3 col-lg-3">
                  <input
                    class="form-check-input"
                    role="radio"
                    type="radio"
                    aria-checked="true"
                    value="no"
                    name="sameShippingAddress"
                    formControlName="sameShippingAddress"
                  />
                  <label class="cx-payment-type-label form-check-label form-radio-label" for="No">
                    <div class="cx-payment-type">No</div>
                  </label>
                </div>
              </div>
              <div>
                <h4 class="dispenser-agreement-order__body__title">
                  {{ 'dispenserAgreement.endUserAddress' | cxTranslate }}
                </h4>
                <div class="form-check col-4 col-md-4 col-lg-4 start-padding">
                  <div class="dispenser-form-info">
                    <span class="label-content">Address Line 1</span>
                    <input
                      class="form-control ng-untouched ng-pristine ng-valid"
                      readonly
                      [value]="endCustomerAddress?.line1"
                      placeholder="Address Line 1"
                    />

                    <span class="label-content">State</span>
                    <input
                      class="form-control ng-pristine ng-valid"
                      readonly
                      [value]="endCustomerAddress?.town"
                      placeholder="State"
                    />
                  </div>
                </div>
                <div class="form-check col-4 col-md-4 col-lg-4">
                  <div class="dispenser-form-info">
                    <span class="label-content">Address Line 2</span>
                    <input
                      class="form-control ng-untouched ng-pristine ng-valid"
                      readonly
                      [value]="endCustomerAddress?.line2 || ''"
                      placeholder="Address Line 2"
                    />

                    <span class="label-content">Postcode</span>
                    <input
                      class="form-control ng-pristine ng-valid ng-untouched"
                      readonly
                      [value]="endCustomerAddress?.postalCode"
                      placeholder="Postcode"
                    />
                  </div>
                </div>
              </div>
            </ng-container>
            <div *ngIf="!endCustomerAddress || addressSelectFormGroup.value.sameShippingAddress == 'no'">
              <h4 class="dispenser-agreement-order__body__title">
                {{ 'dispenserAgreement.shipToAddress' | cxTranslate }}
              </h4>
              <div class="form-check col-4 col-md-4 col-lg-4 start-padding">
                <div class="dispenser-form-info">
                  <span class="label-content">Address Line 1</span>
                  <input
                    tabindex="1"
                    class="form-control ng-untouched ng-pristine ng-valid"
                    formControlName="addressLine1"
                    placeholder="Address Line 1"
                  />

                  <span class="label-content">State</span>
                  <input
                    tabindex="3"
                    class="form-control ng-pristine ng-valid"
                    formControlName="state"
                    placeholder="State"
                  />
                </div>
              </div>
              <div class="form-check col-4 col-md-4 col-lg-4">
                <div class="dispenser-form-info">
                  <span class="label-content">Address Line 2</span>
                  <input
                    tabindex="2"
                    class="form-control ng-untouched ng-pristine ng-valid"
                    formControlName="addressLine2"
                    placeholder="Address Line 2"
                  />

                  <span class="label-content">Postcode</span>
                  <input
                    tabindex="4"
                    class="form-control ng-pristine ng-valid ng-untouched"
                    formControlName="postcode"
                    placeholder="Postcode"
                  />
                </div>
              </div>
            </div>
            <div class="form-group row date-picker">
              <div class="col-4">
                <label>
                  <ng-template #tipContent>
                    <div class="preferred-date-hint">
                      <span>{{ 'checkoutShipping.dispenserPreferredDateHint' | cxTranslate }}</span>
                    </div>
                  </ng-template>
                  <span class="label-content"
                    >Requested Dispatch Date
                    <i class="fas fa-info-circle info-icon" [ngbTooltip]="tipContent"></i>
                  </span>
                  <input
                    [matDatepicker]="picker"
                    [min]="minDate"
                    aria-label="request-delivery-date"
                    class="form-control"
                    type="text"
                    name="requestedDeliveryDate"
                    placeholder="Requested dispatch date"
                    [matDatepickerFilter]="holidaysAndDeliverydaysFilter"
                    formControlName="requestedDeliveryDate"
                    readonly
                  />
                  <mat-datepicker #picker></mat-datepicker>
                </label>
                <button class="btn date-picker__search-icon" (click)="openDatePicker(picker)">
                  <i class="fas fa-calendar-alt"></i>
                </button>
              </div>
              <div class="form-check col-4 col-md-4 col-lg-4">
                <div class="dispenser-form-info">
                  <label>
                    <span class="label-content">{{ 'checkoutPO.poNumber' | cxTranslate }}</span>
                    <input
                      class="form-control ng-untouched ng-pristine ng-valid"
                      type="text"
                      formControlName="poNumber"
                      placeholder="{{ 'checkoutPO.placeholder' | cxTranslate }}"
                      value=""
                    />
                  </label>
                </div>
              </div>
              <div class="form-check col-8 row">
                <app-minimum-dispatch-time></app-minimum-dispatch-time>
              </div>
            </div>
            <div class="form-check col-8 col-md-8 col-lg-8 start-padding">
              <div class="dispenser-form-info">
                <span class="label-content">Delivery Instructions</span>
                <input
                  class="form-control ng-untouched ng-pristine ng-valid"
                  formControlName="deliveryInstructions"
                  placeholder="Enter instructions"
                />
              </div>
            </div>
          </div>

          <div class="action-button">
            <button mat-button matStepperPrevious class="btn btn-action back-button">Back</button>
            <button class="btn btn-primary" [disabled]="disableAddressSelectionForm" mat-button matStepperNext>
              Next
            </button>
          </div>
        </div>
      </mat-card>
    </form>
  </mat-step>
  <mat-step [stepControl]="reviewFormGroup" *ngIf="!shipCreditNote && shipSelection">
    <form [formGroup]="reviewFormGroup" (keydown.enter)="$event.preventDefault()">
      <ng-template matStepLabel
        ><label class="description-title">{{ 'dispenserAgreement.review' | cxTranslate }}</label></ng-template
      >
      <mat-card class="dispenser-agreement-order__body">
        <div *ngIf="!showSubmitLoader">
          <h3 class="dispenser-agreement-order__body__title">
            {{ 'dispenserAgreement.review' | cxTranslate }}
          </h3>
          <div class="dispenser-agreement-order__body__section" *ngIf="shipSelection">
            <div class="dispenser-agreement-order__body__section__content">
              <div class="dispenser-agreement-order__header">
                <div class="form-group row">
                  <div class="col-md-6">
                    <h4>
                      {{ 'dispenserAgreement.shipTo' | cxTranslate }}
                    </h4>
                  </div>
                  <div class="col-md-6 review-edit-button">
                    <button class="btn btn-primary" (click)="moveToStep(0)">
                      <i class="fas fa-pencil-alt info-icon"></i>Edit
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="description-text">
                      {{ ShipmentTypeEnum[shipSelectFormGroup.value.shipToSelect] }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="dispenser-agreement-order__header">
                <div class="form-group row">
                  <div class="col-md-6">
                    <h4>
                      {{ 'dispenserAgreement.dispenserSelection' | cxTranslate }}
                    </h4>
                  </div>
                  <div class="col-md-6 review-edit-button">
                    <button class="btn btn-primary" (click)="moveToStep(0)">
                      <i class="fas fa-pencil-alt info-icon"></i>Edit
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div *ngIf="shipSelection">
                      <div *ngFor="let dispenser of dispensersQuantityMap | keyvalue">
                        {{ dispenser.value?.dispenserQuantity }} x {{ dispenser.key.product.name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dispenser-agreement-order__header" *ngIf="shipEndUserDepot || shipDistributorDepot">
                <div class="form-group row">
                  <div class="col-md-6">
                    <h4>
                      {{ 'dispenserAgreement.addressSelection' | cxTranslate }}
                    </h4>
                  </div>
                  <div class="col-md-6 review-edit-button">
                    <button class="btn btn-primary" (click)="moveToStep(1)">
                      <i class="fas fa-pencil-alt info-icon"></i>Edit
                    </button>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <div *ngIf="shipDistributorDepot">
                      {{
                        distributorAddresses.get(addressSelectFormGroup.value.selectedDistributorAddress)
                          ?.formattedAddress
                      }}
                    </div>
                    <div *ngIf="shipEndUserDepot && addressSelectFormGroup.value.sameShippingAddress == 'yes'">
                      {{ endCustomerAddress?.formattedAddress }}
                    </div>
                    <div *ngIf="shipEndUserDepot && addressSelectFormGroup.value.sameShippingAddress == 'no'">
                      {{ addressSelectFormGroup.value.addressLine1 }}, {{ addressSelectFormGroup.value.addressLine2 }}
                      {{ addressSelectFormGroup.value.postcode }}
                    </div>
                  </div>
                </div>
                <div class="row my-2" *ngIf="addressSelectFormGroup.value.requestedDeliveryDate">
                  <div class="col-md-8">
                    <div class="description-text">
                      {{ 'dispenserShipment.dispatchDate' | cxTranslate }} :
                      {{ addressSelectFormGroup.value.requestedDeliveryDate | cxDate }}
                    </div>
                  </div>
                </div>
                <div class="row my-2" *ngIf="addressSelectFormGroup.value.deliveryInstructions">
                  <span class="col-auto">{{ 'creditClaims.order.deliveryInstructions' | cxTranslate }} :</span>
                  <span class="col-md-8 no-padding">{{ addressSelectFormGroup.value.deliveryInstructions }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="action-button">
            <button mat-button matStepperPrevious class="btn back-button btn-action">Back</button>
            <button mat-button matStepperNext class="btn btn-primary" (click)="placeDispenserOrder()">Submit</button>
          </div>
        </div>
        <div *ngIf="showSubmitLoader" class="cx-spinner">
          <cx-spinner></cx-spinner>
        </div>
      </mat-card>
    </form>
  </mat-step>
</mat-horizontal-stepper>
